import ThreeCardLayout, { ThreeCardLayoutProps } from '@/components/_rebrand/ThreeCardLayout';
import SerifAndSansSerifHeadline, { HeadlineFromCraftProps } from '@/components/_rebrand/craft/product/_organisms/SerifAndSansSerifHeadline';

const displayProps = {
  header: null,
  cards: [],
  exploreTitle: null,
  exploreItems: [],
  exploreImages: null,
} as ThreeCardLayoutProps;

interface FeatureImageFromCraft {
  url: string;
  title: string;
  width: number;
  height: number;
}

interface FeatureGridItemFromCraft {
  headline: string;
  description: string;
  image: FeatureImageFromCraft;
  showComingSoon: boolean;
}

interface ModuleProductFeatureGrid {
  header: HeadlineFromCraftProps;
  featureGridItems: FeatureGridItemFromCraft[];
}

const formCards = (features: FeatureGridItemFromCraft[]): ThreeCardLayoutProps['cards'] => {
  /*
   * Its possible for the features array to exist but have empty image fields
   * Need to include null checks for image arrays
   */
  const cards: ThreeCardLayoutProps['cards'] = features.map((feature) => ({
    image: feature.image?.[0]?.url || "",
    title: feature.headline,
    description: feature.description,
    comingSoon: feature.showComingSoon,
  }));

  return cards;
}

const setDynamicDisplayPropAttributes = (data: ModuleProductFeatureGrid) => {
  displayProps.header = <SerifAndSansSerifHeadline {...data.header[0]} />
  displayProps.cards = formCards(data.featureGridItems)
};

const FeatureGrid = ({ entry }) => {
  const data = Array.isArray(entry?.moduleProductFeatureGrid)
    ? entry.moduleProductFeatureGrid[0]
    : entry?.moduleProductFeatureGrid;

  /*
   * If the section is hidden, return a padded div with background color.
   * In the product 'capability' template where this is used, the section below has zero padding.
   */
  if (data.hideSection) {
    return <div className="bg-violet-900 py-5" />;
  }

  setDynamicDisplayPropAttributes(data);

  return (
    <ThreeCardLayout {...displayProps} />
  );
};

export default FeatureGrid;
